const button = {
    types: {
        default: {
            backgroundColor: 'SNOW_100',
            textColor: 'INK_800',
            hoverBackgroundColor: 'SNOW_100',
            hoverTextColor: 'PRIMARY_600',
            hoverOpacity: 1,
            activeBackgroundColor: 'SNOW_100',
            activeTextColor: 'PRIMARY_700',
            focusTextColor: 'INK_800',
            focusInnerBorderColor: 'PRIMARY_600',
            disabledBackgroundColor: 'SNOW_300',
            disabledBorderColor: 'TRANSPARENT',
            disabledTextColor: 'INK_400',
            iconColor: 'INK_800',
            loadingSpinnerColor: 'PRIMARY_600',
            borderColor: 'TRANSPARENT',
        },
        primary: {
            backgroundColor: 'PRIMARY_600',
            textColor: 'SNOW_100',
            hoverBackgroundColor: 'PRIMARY_500',
            hoverTextColor: 'SNOW_100',
            hoverOpacity: 1,
            activeBackgroundColor: 'PRIMARY_700',
            activeTextColor: 'SNOW_100',
            focusTextColor: 'SNOW_100',
            focusInnerBorderColor: 'PRIMARY_700',
            disabledBackgroundColor: 'PRIMARY_300',
            disabledBorderColor: 'TRANSPARENT',
            disabledTextColor: 'SNOW_100',
            iconColor: 'SNOW_100',
            loadingSpinnerColor: 'SNOW_100',
            borderColor: 'TRANSPARENT',
        },
        destructive: {
            backgroundColor: 'SNOW_100',
            textColor: 'RED_600',
            hoverBackgroundColor: 'SNOW_100',
            hoverTextColor: 'RED_600',
            hoverOpacity: 0.9,
            activeBackgroundColor: 'SNOW_100',
            activeTextColor: 'RED_700',
            focusTextColor: 'RED_600',
            focusInnerBorderColor: 'RED_600',
            disabledBackgroundColor: 'SNOW_300',
            disabledBorderColor: 'TRANSPARENT',
            disabledTextColor: 'INK_400',
            iconColor: 'RED_600',
            loadingSpinnerColor: 'RED_600',
            borderColor: 'TRANSPARENT',
        },
        safe: {
            backgroundColor: 'GREEN_600',
            textColor: 'SNOW_100',
            hoverBackgroundColor: 'GREEN_400',
            hoverTextColor: 'SNOW_100',
            hoverOpacity: 1,
            activeBackgroundColor: 'GREEN_700',
            activeTextColor: 'SNOW_100',
            focusTextColor: 'SNOW_100',
            focusInnerBorderColor: 'GREEN_700',
            disabledBackgroundColor: 'GREEN_300',
            disabledBorderColor: 'TRANSPARENT',
            disabledTextColor: 'SNOW_100',
            iconColor: 'SNOW_100',
            loadingSpinnerColor: 'SNOW_100',
            borderColor: 'TRANSPARENT',
        },
        outline: {
            backgroundColor: 'TRANSPARENT',
            textColor: 'SNOW_100',
            hoverBackgroundColor: 'PRIMARY_A200',
            hoverTextColor: 'SNOW_100',
            hoverOpacity: 1,
            activeBackgroundColor: 'PRIMARY_A400',
            activeTextColor: 'SNOW_100',
            focusTextColor: 'SNOW_100',
            focusInnerBorderColor: 'SNOW_100',
            disabledBackgroundColor: 'TRANSPARENT',
            disabledBorderColor: 'PRIMARY_A400',
            disabledTextColor: 'PRIMARY_A400',
            iconColor: 'SNOW_100',
            loadingSpinnerColor: 'SNOW_100',
            borderColor: 'SNOW_100',
        },
        outlinePrimary: {
            backgroundColor: 'TRANSPARENT',
            textColor: 'PRIMARY_600',
            hoverBackgroundColor: 'PRIMARY_LIGHTER_O40',
            hoverTextColor: 'PRIMARY_600',
            hoverOpacity: 1,
            activeBackgroundColor: 'PRIMARY_LIGHTER_O40',
            activeTextColor: 'PRIMARY_600',
            focusTextColor: 'PRIMARY_600',
            focusInnerBorderColor: 'PRIMARY_500',
            disabledBackgroundColor: 'PRIMARY_200',
            disabledBorderColor: 'PRIMARY_LIGHT',
            disabledTextColor: 'PRIMARY_LIGHT',
            iconColor: 'PRIMARY_600',
            loadingSpinnerColor: 'SNOW_100',
            borderColor: 'PRIMARY_500',
        },
        outlineBasic: {
            backgroundColor: 'TRANSPARENT',
            textColor: 'INK_600',
            hoverBackgroundColor: 'INK_A50',
            hoverTextColor: 'INK_600',
            hoverOpacity: 1,
            activeBackgroundColor: 'INK_A100',
            activeTextColor: 'INK_600',
            focusTextColor: 'INK_600',
            focusInnerBorderColor: 'INK_500',
            disabledBackgroundColor: 'INK_300',
            disabledBorderColor: 'SKY_DARK',
            disabledTextColor: 'INK_400',
            iconColor: 'INK_600',
            loadingSpinnerColor: 'INK_600',
            borderColor: 'INK_500',
        },
        yellow: {
            backgroundColor: 'YELLOW_600',
            textColor: 'INK_800',
            hoverBackgroundColor: 'YELLOW_500',
            hoverTextColor: 'INK_600',
            hoverOpacity: 1,
            activeBackgroundColor: 'YELLOW_600',
            activeTextColor: 'INK_800',
            focusTextColor: 'INK_800',
            focusInnerBorderColor: 'YELLOW_700',
            disabledBackgroundColor: 'YELLOW_300',
            disabledBorderColor: 'TRANSPARENT',
            disabledTextColor: 'INK_400',
            iconColor: 'INK_800',
            loadingSpinnerColor: 'INK_800',
            borderColor: 'TRANSPARENT',
        },
    },
    height: {
        SMALL: '2rem',
        MEDIUM: '2.125rem',
        'MEDIUM-LARGE': '2.25rem',
        LARGE: '2.5rem',
        SQUARE: '2.25rem',
    },
    hPadding: {
        NORMAL: '1rem',
        MEDIUM: '1.0625rem',
        WIDE: '3rem',
        SQUARE: '0.5rem',
    },
    border: {
        NORMAL: '0.0625rem',
        BOLD: '0.125rem',
    },
    borderRadius: {
        NORMAL: '0.375rem',
        NONE: '0rem',
    },
    minWidth: {
        NORMAL: '1rem',
        MEDIUM: '1.0625rem',
        WIDE: '3rem',
        SQUARE: '2.25rem',
    },
};
export default button;
//# sourceMappingURL=buttons.js.map